import './index.css'
import logoDash from '../../assets/Nu Kenzie (2).png'
import { Form } from '../../components/Form/Form'
import { List } from '../../components/LIst/List'
import { TotalMoney} from '../../components/TotalMoney/TotalMoney'

export const Dashboard = ({setPage, page, listTransactions, setListTransactions}) =>{

    const home = (event) =>{
        event.preventDefault()
        setPage('home')
    }

    return(
        <div className='container-dash-global'>
            <header className='container-dash'>
                <img src={ logoDash } alt="logo-dash" />
                <button type='submit' onClick={(event) => home(event) }>Início</button>
            </header>
            <div className='container-main-dash'>
                <div className='container-data'>
                    <Form listTransactions={listTransactions}  setListTransactions={setListTransactions}/>
                    <TotalMoney listTransactions={listTransactions}  setListTransactions={setListTransactions}/>
                </div>
                <div className='container-money'>
                    <List listTransactions={listTransactions}  setListTransactions={setListTransactions}/>
                </div>
            </div>

        </div>
    )
}